import React, { useContext, useState } from 'react'
import { DataContext } from './DataContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

const filterModes = ['Selected Wells', 'All Wells']
const FilterModeSelector = ({
    displayFilterModeDropdown,
    setDisplayFilterModeDropdown,
    filterMode,
    setFilterMode,
}) => {
    const { colorClass } = useContext(PanelStyleContext)

    return displayFilterModeDropdown ? (
        <div className="timeWindowDropdownWrapper">
            {filterModes.map(option => (
                <div
                    key={`filterMode-${option}`}
                    className="timeWindowOptionWrapper"
                    onClick={() => {
                        setFilterMode(option)
                        setDisplayFilterModeDropdown(false)
                    }}
                >
                    <div
                        className={`timeWindowOptionText ${
                            option === filterMode
                                ? 'activeOption ' + colorClass
                                : ''
                        }`}
                    >
                        {option}
                    </div>
                </div>
            ))}
        </div>
    ) : null
}

export default FilterModeSelector
export { filterModes }
